import { throwApiError } from './apiError';

const API_BASE_URL = '/auth';

export const registerUser = async (name, email, password) => {
  const userData = { name, email, password };
  
  const response = await fetch(`${API_BASE_URL}/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    await throwApiError(response);
  }
  
  return response.text();
};

export const loginUser = async (email, password) => {
  const userData = { email, password };

  try {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (response.ok) {
      const data = await response.json();
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);
      return data;
    } else {
      await throwApiError(response);
    }
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async () => {
  const token = localStorage.getItem('refresh_token'); 
  
  try {
    await fetch(`${API_BASE_URL}/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`
      },
      body: JSON.stringify({ refresh_token: token }),
    });
  } catch (error) {
    console.error("Logout failed on server", error);
  }
};

export const getCurrentUser = async () => {
  const token = localStorage.getItem('access_token');
  if (!token) return null;

  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/me`, {
      method: 'GET',
    });

    if (response && response.ok) {
      return await response.json();
    }

    return null;
  } catch (error) {
    console.error('Error fetching user:', error);
    return null;
  }
};

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refresh_token');

  if (!refreshToken) {
    return null;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    if (!response.ok) {
        throw new Error('Refresh failed');
    }

    const data = await response.json();

    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);

    return data;
  } catch (error) {
    console.error('Error refreshing access token:', error);
    return null;
  }
};

export const fetchWithAuth = async (url, options = {}, token = null) => {
  const accessToken = token || localStorage.getItem('access_token');

  if (!accessToken) {
    console.error('No access token found');
    return null;
  }

  const isFormData = options.body?.constructor?.name === 'FormData';

  const updatedOptions = {
    ...options,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    let response = await fetch(url, updatedOptions);
    
    if (response.status === 401 || response.status === 403) {
        const refreshData = await refreshAccessToken();

        if (!refreshData) {
            return null;
        }

        const newOptions = {
            ...updatedOptions,
            headers: {
                ...updatedOptions.headers,
                Authorization: `Bearer ${refreshData.access_token}`,
            },
        };

        response = await fetch(url, newOptions);
    }

    return response;

  } catch (error) {
    console.error("Error in fetchWithAuth:", error);
    return null;
  }
};

export const fetchWithOptionalAuth = async (url, options = {}) => {
  const token = localStorage.getItem('access_token');

  if (token) {
    return await fetchWithAuth(url, options, token);
  }

  const defaultOptions = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  return await fetch(url, defaultOptions);
};